(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["br-payment-terms"] && !Shopify.designMode) return;
  try {
    class BrPaymentTerms extends HTMLElement {
    connectedCallback() {
      this.handleVariantUpdate = this.handleVariantUpdate.bind(this);
      document.addEventListener('variant:update', this.handleVariantUpdate);
    }

    disconnectedCallback() {
      document.removeEventListener('variant:update', this.handleVariantUpdate);
    }

    handleVariantUpdate(event) {
      const eventProductId = event.detail?.data?.productId;
      if (String(eventProductId) !== this.dataset.productId) return;

      const price = Number(event.detail?.resource?.price);
      if (!Number.isFinite(price)) return;

      this.updateAmounts(price);
    }

    updateAmounts(price) {
      const minimumTwo = Number(this.dataset.minimumTwo);
      const minimumThree = Number(this.dataset.minimumThree);
      const pixDiscount = Number(this.dataset.pixDiscount);
      let installments = 1;

      if (price >= minimumThree) {
        installments = 3;
      } else if (price >= minimumTwo) {
        installments = 2;
      }

      const formatter = new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: this.dataset.currency || 'BRL'
      });

      this.querySelector('[data-installment-prefix]').textContent = installments === 1 ? 'No cartão: ' : 'Ou em até ';
      this.querySelector('[data-installment-count]').textContent = installments;
      this.querySelector('[data-installment-value]').textContent = formatter.format(price / installments / 100);
      this.querySelector('[data-pix-value]').textContent = formatter.format(Math.round(price * (100 - pixDiscount) / 100) / 100);
    }
  }

  if (!customElements.get('br-payment-terms')) {
    customElements.define('br-payment-terms', BrPaymentTerms);
  }
  } catch(e) { console.error(e); }
})();

})();
